module.exports = __webpack_public_path__ + "static/media/abhilashnalegaonkar.334ff6d5.jpg";